module.exports = __webpack_public_path__ + "static/tetleys-coaches-acquired-by-first-sm-53934da1d39bee1b2c596ee19d692106.jpg";